import { Component, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { IFooterItem } from "src/app/dtos/footer-item.dto";
import { FooterService } from "src/app/services/footer.service";
import { ContactComponent } from '../../shared/components/contact/contact.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'fspro-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  isLoadingFooter = false;
  footerItems = [];

  public currentYear;

  constructor(private footerService: FooterService, private readonly dialog: MatDialog) {
    this.currentYear =  new Date().getFullYear();

  }
  ngOnInit(): void {
    this.isLoadingFooter = true;
    this.footerService.getFooter().pipe(finalize(() => this.isLoadingFooter = false)).subscribe((items: IFooterItem[]) => {
      this.footerItems = items.filter(i => i.is_active && i.is_footer).sort(function(a, b){return a.position - b.position});;
    });
  }

  onOpenContact() {
    this.dialog.open(ContactComponent, {
      width: '480px',
      panelClass: ['send-message-dialog-panel-class', 'large'],
      disableClose: true
    });
  }

}
